import { render } from "./CardSliderCard.vue?vue&type=template&id=95c40d04&scoped=true"
import script from "./CardSliderCard.vue?vue&type=script&lang=js"
export * from "./CardSliderCard.vue?vue&type=script&lang=js"

import "./CardSliderCard.vue?vue&type=style&index=0&id=95c40d04&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c40d04"]])

export default __exports__